/** v2 onboarding step orders (v1 uses 0–3). */
export const ONBOARDING_V2_STEP = {
  complete: 10,
  bootstrap: 11,
  intent: 12,
  team: 13,
} as const;

const OPEN_SIGNUP_BOOTSTRAP_TEAM_NAME =
  /^(Swift|Bright|Bold|Clear|Prime|Nova|Apex|Core)\s+(Studio|Labs|Works|Collective|Workshop|Foundry|Guild|Team)\s+\d{3}$/;

/** True when the org name is still the open-signup bootstrap placeholder. */
export function isOpenSignupBootstrapTeamName(
  name: string | null | undefined,
): boolean {
  return OPEN_SIGNUP_BOOTSTRAP_TEAM_NAME.test(name?.trim() ?? "");
}
